/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiQueryTemplate
 */
export interface ApiQueryTemplate {
    /**
     * 
     * @type {number}
     * @memberof ApiQueryTemplate
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiQueryTemplate
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ApiQueryTemplate
     */
    content: string;
    /**
     * 
     * @type {ApiQueryTemplateStatusEnum}
     * @memberof ApiQueryTemplate
     */
    status: ApiQueryTemplateStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ApiQueryTemplate
     */
    handle: string;
}

/**
* @export
* @enum {string}
*/
export enum ApiQueryTemplateStatusEnum {
    DRAFT = 'DRAFT',
    ACTIVE = 'ACTIVE'
}


/**
 * Check if a given object implements the ApiQueryTemplate interface.
 */
export function instanceOfApiQueryTemplate(value: object): value is ApiQueryTemplate {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('handle' in value) || value['handle'] === undefined) return false;
    return true;
}

export function ApiQueryTemplateFromJSON(json: any): ApiQueryTemplate {
    return ApiQueryTemplateFromJSONTyped(json, false);
}

export function ApiQueryTemplateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiQueryTemplate {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'],
        'content': json['content'],
        'status': json['status'],
        'handle': json['handle'],
    };
}

export function ApiQueryTemplateToJSON(json: any): ApiQueryTemplate {
    return ApiQueryTemplateToJSONTyped(json, false);
}

export function ApiQueryTemplateToJSONTyped(value?: ApiQueryTemplate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'content': value['content'],
        'status': value['status'],
        'handle': value['handle'],
    };
}

